export const emailInfoContent = (
  <div className="space-y-6">
    <div className="mb-4">
      <p className="mb-4 text-gray-700">
        The Email System automatically generates follow-up emails based on your AI assistant's phone conversations.
        This system eliminates awkward silences during calls by generating emails after the conversation ends.
      </p>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <h4 className="font-medium text-blue-900 mb-2">How it works:</h4>
        <ol className="text-sm text-blue-800 space-y-1">
          <li>1. During a call, your AI can offer to send follow-up emails</li>
          <li>2. The system queues the email request without interrupting the conversation</li>
          <li>3. After the call ends, AI generates the email based on the full transcript</li>
          <li>4. You review and approve the email before it's sent</li>
          <li>5. Approved emails are automatically delivered via professional email service</li>
        </ol>
      </div>

      {/* <div className="space-y-6">
        <div>
          <h4 className="font-medium mb-2">1. Email Queue Overview</h4>
          <p className="text-sm text-gray-600 mb-3">Learn how to manage your email queue and review AI-generated emails</p>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.loom.com/embed/placeholder-video-id"
              frameBorder="0"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
            />
          </div>
        </div>

        <div>
          <h4 className="font-medium mb-2">2. Customizing Email Templates</h4>
          <p className="text-sm text-gray-600 mb-3">How to create and customize email generation prompts</p>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.loom.com/embed/placeholder-video-id"
              frameBorder="0"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
            />
          </div>
        </div>
      </div> */}
    </div>
  </div>
);